import React from "react";

const LogoIcon = () => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.3"
        x="6.76245"
        width="49.6998"
        height="49.6998"
        rx="12"
        transform="rotate(7.82022 6.76245 0)"
        fill="#222130"
      />
      <rect
        x="5.06885"
        y="5.64497"
        width="45.1598"
        height="45.1598"
        rx="12"
        fill="#222130"
      />
      <path
        d="M16.3589 32.4586V24.2734L23.4151 20.0396L30.7536 24.2734L23.6973 28.2249V36.6923L16.3589 32.4586Z"
        fill="white"
      />
      <path
        d="M31.7444 15.1023L38.8307 19.1988L38.9647 27.4266L31.6266 31.661L31.737 23.5745L24.4063 19.3367L31.7444 15.1023Z"
        fill="white"
      />
      <path
        d="M38.8216 37.1661L31.7292 41.2522L24.5383 37.2516L24.5433 28.7795L31.4897 32.921L38.8266 28.694L38.8216 37.1661Z"
        fill="white"
      />
    </svg>
  );
};

export default LogoIcon;
